function productContentTabs() {
  document.querySelectorAll('.product-content-tabs').forEach((section) => {
    const navigationItems = section.querySelectorAll('.tabs-navigation-item');
    const navigationSelect = section.querySelector('.tabs-navigation-select');
    const panels = section.querySelectorAll('.product-content-tabs__panel');

    if (!panels.length) return;

    const activateTab = (tabId) => {
      if (!tabId) return;

      navigationItems.forEach((item) => {
        const isActive = item.dataset.tab === tabId;
        item.classList.toggle('active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach((panel) => {
        const isActive = panel.dataset.tabId === tabId;
        panel.classList.toggle('active', isActive);
        panel.toggleAttribute('hidden', !isActive);
      });

      if (navigationSelect) {
        navigationSelect.value = tabId;
      }
    };

    if (window.innerWidth >= 990) {
      navigationItems.forEach((item) => {
        item.addEventListener('click', () => activateTab(item.dataset.tab));
        item.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            activateTab(item.dataset.tab);
          }
        });
      });
    } else if (navigationSelect) {
      navigationSelect.addEventListener('change', () => activateTab(navigationSelect.value));
    }
  });
}

document.addEventListener('DOMContentLoaded', productContentTabs);
document.addEventListener('shopify:section:load', productContentTabs);
